import { GeckoAssetModelType, GeckoMeasurementUnit } from 'types'

import { Resolution } from './rugReportData'
import {
  ReportedAssetType,
  ReportInspectionSurface,
  ReportMaterialType,
  SensorPayloadType,
} from './types'

export const DEFAULT_SENSOR_DIAMETER = {
  value: 0.125,
  unit: GeckoMeasurementUnit.Inches,
}

export const SENSOR_PAYLOAD_TYPE_TO_FREQUENCY: Record<
  SensorPayloadType,
  number | undefined
> = {
  [SensorPayloadType.THICK]: 5,
  [SensorPayloadType.TANK]: 7.5,
  [SensorPayloadType.THIN]: 10,
  [SensorPayloadType.UNKNOWN]: undefined,
  [SensorPayloadType.MIXED]: undefined,
}

export const DEFAULT_ASSET_TYPE_MAPPING: Partial<
  Record<GeckoAssetModelType, ReportedAssetType>
> = {
  [GeckoAssetModelType.VerticalTank]: ReportedAssetType.AST,
  [GeckoAssetModelType.HorizontalTank]: ReportedAssetType.AST,
  [GeckoAssetModelType.Piping]: ReportedAssetType.PIPING,
  [GeckoAssetModelType.LegacyBoiler]: ReportedAssetType.BOILER,
}

export const DEFAULT_ASSET_MATERIAL_MAPPING: Partial<
  Record<GeckoAssetModelType, ReportMaterialType>
> = {
  [GeckoAssetModelType.LegacyBoiler]: ReportMaterialType.CARBON_STEEL,
}

export const DEFAULT_INSPECTION_RESOLUTION_MAPPING: Partial<
  Record<GeckoAssetModelType, Resolution>
> = {
  [GeckoAssetModelType.VerticalTank]: {
    width: 1,
    widthUnit: GeckoMeasurementUnit.Inches.id,
    height: 1,
    heightUnit: GeckoMeasurementUnit.Inches.id,
  },
  [GeckoAssetModelType.HorizontalTank]: {
    width: 1,
    widthUnit: GeckoMeasurementUnit.Inches.id,
    height: 1,
    heightUnit: GeckoMeasurementUnit.Inches.id,
  },
  [GeckoAssetModelType.LegacyBoiler]: {
    width: 1,
    widthUnit: 'tube',
    angles: 3,
    height: 0.25,
    heightUnit: GeckoMeasurementUnit.Inches.id,
  },
}

export const DEFAULT_DELIVERABLE_RESOLUTION_MAPPING: Partial<
  Record<GeckoAssetModelType, Resolution>
> = {
  [GeckoAssetModelType.VerticalTank]: {
    width: 3,
    widthUnit: GeckoMeasurementUnit.Inches.id,
    height: 3,
    heightUnit: GeckoMeasurementUnit.Inches.id,
  },
  [GeckoAssetModelType.HorizontalTank]: {
    width: 3,
    widthUnit: GeckoMeasurementUnit.Inches.id,
    height: 3,
    heightUnit: GeckoMeasurementUnit.Inches.id,
  },
  [GeckoAssetModelType.LegacyBoiler]: {
    width: 1,
    widthUnit: 'tube',
    angles: 3,
    height: 1,
    heightUnit: GeckoMeasurementUnit.Feet.id,
  },
}

export const DEFAULT_INSPECTION_SURFACE_LOCATION_MAPPING: Partial<
  Record<GeckoAssetModelType, ReportInspectionSurface>
> = {
  [GeckoAssetModelType.VerticalTank]: ReportInspectionSurface.OD,
  [GeckoAssetModelType.HorizontalTank]: ReportInspectionSurface.OD,
  [GeckoAssetModelType.LegacyBoiler]: ReportInspectionSurface.FIRESIDE,
}
